import { render, staticRenderFns } from "./CategoriaProductoForm.vue?vue&type=template&id=8e416a4e&"
import script from "./CategoriaProductoForm.vue?vue&type=script&lang=js&"
export * from "./CategoriaProductoForm.vue?vue&type=script&lang=js&"
import style0 from "./CategoriaProductoForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports